<div class="logo">
  <img [src]="logoSource" height="84">
</div>